import useResizeObserver from "@react-hook/resize-observer";
import { useRouter } from "next/router";

import { postIframeData } from "@/lib";
import { Box } from "@/storybook-components";
import type { ReactNode } from "react";

interface EmbedsLayoutProps {
  children: ReactNode;
  [key: string]: any;
}

const EmbedsLayout = ({ children, ...rest }: EmbedsLayoutProps) => {
  const { query } = useRouter();
  const { hostOrigin } = query as { hostOrigin: string };

  useResizeObserver(
    hostOrigin && process.browser ? document.documentElement : null,
    (entry) =>
      postIframeData({
        hostOrigin,
        height: entry.contentRect.height,
        location: document.location.href
      })
  );

  return (
    <Box as="main" {...rest}>
      {children}
    </Box>
  );
};

export default EmbedsLayout;
